import React, { Component } from 'react'
import Papa from 'papaparse';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
// import Slide from '@material-ui/core/Slide';
import { Card, CardContent, Grid, Paper } from '@material-ui/core';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress'; 
import CardMedia from '@material-ui/core/CardMedia';
// import Chip from '@material-ui/core/Chip';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

const styles = (theme) => ({
	content: {
			flexGrow: 1,
			padding: theme.spacing(3),
	},
	p: {
		display: 'block',
	},
	root: {
		flexGrow : 1,
		background: 'transparent',
	},
	option: {
			color: "#495057",
  },
	pos: {
		paddingRight: 5
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	dialogStyle: {
		maxWidth: '60%'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	media: {
			height: 250,
			cursor: 'pointer'
	},
	tags: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
		'& > *': {
				margin: theme.spacing(0.5),
		},
	},
	searchBox: {
		borderColor: '#968847',
	}
});

function Proper(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class movements extends Component {
	constructor(props) {
		super(props);

		this.state = {
			media: [],
			searchResults: [],
			id: '',
			errors: [],
			filters: {
				active: true,
				sort: 'Name'
			},
			lexicon: {
				movement: '',
				body_direction: '',
				tags: ''
			},
			menu: {
				filter: {
					category: '',
					query: ''
				},
				movement_categories: '',
			},
			uiLoading: true,
			buttonType: '',
			viewOpen: false,

			hover:false
		};

		this.handleViewOpen = this.handleViewOpen.bind(this);
		this.updateData = this.updateData.bind(this);
	}


	componentDidMount = () => {
		Papa.parse("database.csv",
			{
				download: true,
				header: true,
				workder: true,
				skipEmptyLines: true,
				complete: this.updateData
		});

	};

	updateData(results){
		this.setState({ media: results.data
									, searchResults: results.data
									, uiLoading: false
									, menu: {
										movement_categories: new Set(results.data.map((x) => x['Movement Category'])),
										filter: { query: '' }	
									}
			});
	}


	handleViewOpen(data) {
		// console.log(data.['Filename'])
		this.setState({
			active: true,
			media_type: data.item.Category.replace(/Japanese Movement/g,'clips').toLowerCase(),
			media_name: data.item.media_name,
			media_filename: data.item?.['Filename'],
			description: data.item?.['Movement Instruction'],
			lexicon: {
				aesthetics: data.item?.['Style'],
				body_direction: data.item?.['Body direction'],
				movement: data.item?.['Movement Category'],	
				body_part: data.item?.['Material/Body part'],	
				tension: data.item?.['Movement quality-tension'],	
				emotional_effect: data.item?.['Mood/Emotional association to the gesture'],	
				meaning: data.item?.['Meaning behind the movement'],	
				spatial_level: data.item?.['Spatial level, Stationary/traveling/traveling big, Weight shift, Body direction changes'],	
				spatial_range: data.item?.['Spatial range/ size of the movement'],	
				size: data.item?.['Spatial range/ size of the movement'],
				tags: data.item?.['tags']
			},
			viewOpen: true
		});
	}
	render() {

		const DialogTitle = withStyles(styles)((props) => {
			const { children, classes, onClose, ...other } = props;
			return (
				<MuiDialogTitle disableTypography className={classes.root} {...other}>
					<Typography variant="h6" style={{color:"#495057"}}>{children}</Typography>
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					) : null}
				</MuiDialogTitle>
			);
		});

		const Pair = withStyles(styles)((props) => {
			const { classes } = props;
			return (<div style={{display:"flex"}}>
						<Typography className={classes.pos} color="textSecondary" component="p" variant="overline" display="inline" noWrap>
							{props.left}
						</Typography>

						<Typography component="p" variant="overline" display="inline" noWrap style={{color: "#495057"}}>
							{props.right}
						</Typography>
						
						</div>
			);
		});

		const PairWithTags = withStyles(styles)((props) => {
			const { classes } = props;
			return (<div style={{display:"flex"}}>
						<Typography className={classes.pos} color="textSecondary" component="p" variant="overline" display="inline" noWrap>
							{props.left}
						</Typography>
						{props.right.split(",").map((item,index) => (
									item!=="" ?
									<>
									<Typography component="a" variant="overline"  href={props.lex+item.toLowerCase().trim()} value={index} key={item+"c"} name={item} style={{color: "#9c70ca", textDecoration: 'none'}} >{item.trim()}{', '}</Typography>
									<Typography component="body">{' '}</Typography>
									</>
									: ""
								)
							)}
						
						</div>
			);
		});

    const baseurl = "https://storage.googleapis.com/mimo-cat-f82c7";

		dayjs.extend(relativeTime);
		const { classes } = this.props;
		const { viewOpen } = this.state;

		const handleViewClose = () => {
			this.setState({ viewOpen: false });
		};

		const searchFilter = (event, value, reason) => {
			switch (reason) {
				case 'clear':
					this.setState({ searchResults: this.state.media, menu: { filter: { query: '' } } }); 
					break;
				case 'select-option':
					// let Index = Number(event.target.dataset.optionIndex);
					let text = event.target.textContent;
					let name = text.split(" ")[0];
					this.setState({ searchResults: this.state.media.filter((data) =>  data.media_name === name )
												, menu: { filter: { query: name } } });
					break;
				case 'create-option':
					let qry = event.target.value;
					let filteredItems = this.state.media.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(qry.toLowerCase()) !== -1);
					this.setState({ searchResults: filteredItems, menu: { filter: { query: qry } } }); 
					break;
				default:
					console.log(`Sorry, we are out of ${reason}.`);
			}

		};


		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</main>
			);
		} else {

			return (
				<main className={classes.content} key="contentMovement">
					<Typography gutterBottom variant="h4" color="textSecondary">Movements</Typography>
					<Paper className={classes.root} >
						<CardContent>
						<div className={classes.progress} />

						<Autocomplete
							freeSolo
							id="search2"
							size='small'
							inputValue={this.state.media.filter.query}
							options={this.state.media}
							getOptionLabel={(option) => 
									{ if (option.hasOwnProperty('media_name')) {
											return option.media_name + ' ' + option.['Movement Instruction'];
										}
									return option}}
							renderInput={(params) => (
									<TextField {...params}
										label={ (this.state.menu.filter.query) ?  this.state.menu.filter.query
											: 'Search for movement' }
										margin="normal"
										variant="outlined"
										color="primary"
										style={{ background: "#333" }}
									/>
							)}
							onChange={searchFilter}
							classes={{ option: classes.option }}
									/>
						</CardContent>
					</Paper>
								
					<br />
					<Grid container spacing={2}>
						{this.state.searchResults.map((item) => (
							<Grid item xs={12} sm={6} md={4} key={item.media_name}>
								<Card variant="outlined"> 
										<CardMedia
												key={item.media_name}
												component={"img"}
												className={classes.media}
												title={item.Filename}
												image={`${baseurl}/${item.Category.replace(/Japanese Movement/g,'clips').toLowerCase()}/thumbnail/${item.Filename.split('.')[0]}.jpg`}
										/>
									<CardContent>
									<Typography variant="h5" component="h2" style={{color:"#495057"}}>
										{item.media_name} {' '} <Typography color="textSecondary" display="inline" >({item.['Movement Category']})</Typography>
									</Typography>
									<Pair left={'Body Part: '} right={item['Material/Body part']} />
									<Pair left={'Mood: '} right={item['Mood/Emotional association to the gesture']} />

									</CardContent>
									<CardActions>
										<Button size="small" color="secondary" onClick={() => this.handleViewOpen({ item })}>
											Learn More {' '}
										</Button>
									</CardActions>
								</Card>
							</Grid>
						))}
					</Grid>

					<Dialog
						onClose={handleViewClose}
						aria-labelledby="movement-details"
						open={viewOpen}
						fullWidth
						maxWidth={"lg"}
					>
						<DialogTitle id="movement-details-title" onClose={handleViewClose}>
							{this.state.media_name}
						</DialogTitle>
						<DialogContent dividers>
						<Grid container spacing={3}>
							<Grid item  xs={12} sm={6} md={6}>
								<div className={classes.image}>
									<CardMedia
													component="video"
													title={this.state.media_name}
													image={`${baseurl}/${this.state.media_type}/${this.state.media_filename}`}
													// style={ {"min-height": 400 }}
													autoPlay
													controls
											/>
								</div>
							</Grid>
							<Grid item  xs={12} sm={6} md={6} container>
								<Grid item xs container direction="column" spacing={2}>
									<Grid item xs>
										<Typography gutterBottom variant="h5" component="h2" style={{color:"#495057"}}>
										{this.state.media_name}
										</Typography>
										<Pair left={'Instruction:'} right={this.state.description} />
										<PairWithTags left={'Movement:'} right={this.state.lexicon.movement} lex={'/lexicon/category/'} />
										<Pair left={'Body Part:'} right={this.state.lexicon.body_part} />
										<PairWithTags left={'Mood:'} right={this.state.lexicon.emotional_effect} lex={'/lexicon/mood/'} />
										<Pair left={'Style:'} right={this.state.lexicon.aesthetics} />
										<Pair left={'Body Direction:'} right={this.state.lexicon.body_direction} />
										<PairWithTags left={'Body Tension:'} right={this.state.lexicon.tension} lex={'/lexicon/tension/'}/>
										{/* <Pair left={'Meaning:'} right={this.state.lexicon.meaning} /> */}
										<PairWithTags left={'Spatial Level:'} right={this.state.lexicon.spatial_level} lex={'/lexicon/spatial_level/'} />
										<PairWithTags left={'Spatial Range:'} right={this.state.lexicon.spatial_range} lex={'/lexicon/spatial_range/'} />
										<Pair left={'Size :'} right={this.state.lexicon.size} />
									</Grid>
								</Grid>
							</Grid>
						</Grid>

				
										
						</DialogContent>
					</Dialog>
				</main>
			);
		}
	}
}

export default (withStyles(styles)(movements));

